import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const LineStreamConst = Object.freeze({
  TYPE_LOGISTIC: 'LOGISTIC',


  map(type: string): string {
    const map = {
      'LOGISTIC': 'ช่องขนส่ง',
    }
    return map[type]
  },
})


export class LineStream extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  enabled: boolean | null
  type: string | null

  stream_trucks_id: number[]
  stream_trucks: []
  getResourceURL(): string {
    return Helper.setting.line_stream.getResourceAPI
  }


}

export class DataLineStreamsArray extends DataArray {

  declare data: LineStream[]
  filter: FilterLineStream = new FilterLineStream()
}


export class FilterLineStream {
  price_group: FilterSet = new FilterSet()
}


export class DataLineStream extends DataResource {

  declare data: LineStream

}
